export const chipsBurned = {
	title: "Fichas quemadas",
	filename: "fichas-quemadas_{{date}}",
	subtitle: "Informe de fichas quemadas por bar",
	filterByPeriod: "Filtrar por período",
	filterByBar: "Filtrar por bar",
	filterByBarPlaceholder: "Seleccione el(los) bar(es)",
	eventPeriod: "Período del evento",
	statusRunning: "(en curso)",
	columns: {
		bar: "Bar",
		product: "Producto",
		quantity: "Cantidad",
		value: "Valor",
		total: "Total",
	},
};
